export type Season = 'spring' | 'summer' | 'autumn' | 'winter'

export const SEASONS: readonly Season[] = ['spring', 'summer', 'autumn', 'winter']

/** 日本の暦の感覚で分ける。紅葉は9月の終わりから色づき、11月に盛りを迎える */
export function seasonFromDate(d: Date): Season {
  const m = d.getMonth() + 1
  if (m >= 3 && m <= 5) return 'spring'
  if (m >= 6 && m <= 8) return 'summer'
  if (m >= 9 && m <= 11) return 'autumn'
  return 'winter'
}

export function parseSeason(v: unknown): Season | null {
  return SEASONS.includes(v as Season) ? (v as Season) : null
}
